/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InitiateLyraReferralRequest } from '../models/InitiateLyraReferralRequest';
import type { SuccessInitiateLyraReferralResponse } from '../models/SuccessInitiateLyraReferralResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LyraPartnerService {

    /**
     * Initiates a Lyra referral by generating a handshake token and redirect URL
     * Creates a handshake token for the authenticated user and returns a redirect URL to Lyra's registration page.
     * @param requestBody
     * @returns SuccessInitiateLyraReferralResponse OK
     * @throws ApiError
     */
    public static initiateLyraReferral(
        requestBody: InitiateLyraReferralRequest,
    ): CancelablePromise<SuccessInitiateLyraReferralResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/partners/lyra/initiate-referral',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
